/**
 * SurgeScreen (Fase 10 · §35) — seleção de RIFT SURGE de uma região concluída. O jogador
 * escolhe NORMAL ou um tier de Surge (I/II/III, desbloqueados por conclusão + maestria).
 * Sem timer/energia/daily (§47). Segue o padrão modal (overlay/panel/void-panel).
 */
import { i18n } from "../i18n/i18n";

export interface SurgeOption {
  tier: number; // 1..3
  unlocked: boolean;
  active: boolean;
  descKey: string; // descrição dos modificadores
  objective: string; // objetivo do Surge (§54)
}
export interface SurgeView {
  regionName: string;
  activeTier: number; // 0 = normal
  options: SurgeOption[];
}
export interface SurgeScreenHandlers {
  onActivate: (regionId: string, tier: number) => void;
  onDeactivate: (regionId: string) => void;
  onClose: () => void;
}

export class SurgeScreen {
  private readonly root: HTMLDivElement;
  private readonly body: HTMLDivElement;
  private readonly closeBtn: HTMLButtonElement;
  private regionId = "";
  private provider: (() => SurgeView) | null = null;

  constructor(uiRoot: HTMLElement, private readonly handlers: SurgeScreenHandlers) {
    this.root = document.createElement("div");
    this.root.className = "overlay";
    this.root.hidden = true;
    this.root.innerHTML = `
      <div class="panel surge-panel void-panel">
        <h2></h2>
        <div class="surge-body"></div>
        <button class="btn primary" data-a="close"></button>
      </div>`;
    uiRoot.appendChild(this.root);
    this.body = this.root.querySelector(".surge-body")!;
    this.closeBtn = this.root.querySelector('[data-a="close"]')!;
    this.closeBtn.onclick = () => this.handlers.onClose();
    i18n.onChange(() => {
      if (!this.root.hidden) this.render();
    });
  }

  open(regionId: string, provider: () => SurgeView): void {
    this.regionId = regionId;
    this.provider = provider;
    this.render();
    this.root.hidden = false;
  }
  close(): void {
    this.root.hidden = true;
  }

  private render(): void {
    if (!this.provider) return;
    const v = this.provider();
    (this.root.querySelector("h2") as HTMLElement).textContent = i18n.t("surge.title");
    this.closeBtn.textContent = i18n.t("world.close");

    let html = `<div class="surge-region">${v.regionName}</div><div class="surge-tiers">`;
    // opção NORMAL
    const normalActive = v.activeTier === 0;
    html += `
      <div class="surge-opt${normalActive ? " active" : ""}">
        <div class="surge-info"><span class="surge-name">${i18n.t("surge.normal")}</span><span class="surge-desc">${i18n.t("surge.normalDesc")}</span></div>
        <button class="btn surge-go" data-tier="0" ${normalActive ? "disabled" : ""}>${normalActive ? i18n.t("surge.on") : i18n.t("surge.select")}</button>
      </div>`;
    for (const o of v.options) {
      const cls = "surge-opt" + (o.active ? " active" : "") + (o.unlocked ? "" : " locked");
      const btn = o.active
        ? `<button class="btn surge-go" disabled>${i18n.t("surge.on")}</button>`
        : o.unlocked
          ? `<button class="btn primary surge-go" data-tier="${o.tier}">${i18n.t("surge.activate")}</button>`
          : `<button class="btn surge-go" disabled>${i18n.t("surge.locked")}</button>`;
      html += `
        <div class="${cls}">
          <div class="surge-info">
            <span class="surge-name">${i18n.t("surge.tierName", { n: o.tier })}</span>
            <span class="surge-desc">${i18n.t(o.descKey)}</span>
            <span class="surge-obj">${o.objective}</span>
          </div>
          ${btn}
        </div>`;
    }
    html += `</div>`;
    this.body.innerHTML = html;

    this.body.querySelectorAll<HTMLButtonElement>("[data-tier]").forEach((b) => {
      const tier = parseInt(b.dataset.tier!, 10);
      b.onclick = () => (tier === 0 ? this.handlers.onDeactivate(this.regionId) : this.handlers.onActivate(this.regionId, tier));
    });
  }
}
